import {useLocalStorage} from '@rehooks/local-storage';
import {LocalStorageKeys} from '../common/types';

export const useIsRieltorApp = () => {
  const [isRieltorApp] = useLocalStorage(LocalStorageKeys.IsRieltorApp);

  return !!isRieltorApp;
}